import _ from "lodash"
import { List, Map } from "immutable"

import cuckoo from "common/services/cuckoo/cuckoo"
import mapperJourney from "common/services/journey/mapperJourney"
import { cuckooEvents } from "common/consts/enums"

export default function(input, airlines) {
  try {
    return _.reduce(
      input,
      (acc, item) =>
        acc.push(
          Map({
            journey: mapperJourney(_.omit(item, "segments_to_order"), "", false, airlines),
            segmentToChange: item.segments_to_order, // Weird naming
          }),
        ),
      List(),
    )
  } catch (err) {
    cuckoo.error(cuckooEvents.INTERNAL_MAPPER_PENDING_FLIGHT_CHANGE_OPTIONS_UNSUPPORTED_FORMAT, {
      input,
      err,
    })
    return null
  }
}
